export default __webpack_public_path__ + "ribbon-tie.svg";